let routeNames = {
    HOME: '/',
    PLAY: '/play',
    SIGN_UP: '/sign-up',
    SUCCESS: '/success',
    VENUES: '/venues/:unique/:type',
    VENUE: '/venue',
    ALREADY_REDEEMED: '/already-redeemed',
    ALREADY_REDEEMED_NO_LIMIT: '/not-available/limit',
    PROMOTION_CLOSED: '/closed',
    LOCATION_CHECK: '/location-check/:unique/:type',
    COOKIE_POLICY: '/cookie-policy',
    PRIVACY_POLICY: '/privacy-policy',
    PROMOTION_TERMS: '/promotion-terms',
    TERMS_CONDITIONS: '/terms',
    REDEEM: '/redeem',
    VOUCHER: '/voucher',
    REDEEM_SUCCESS: '/redeem-success',
    RESEND_EMAIL: '/resend-email',
    FAQ: '/faqs',
    LOCATION_ERROR: '/location-error/:unique/:type',
    NOT_AVAILABLE: '/not-available',
    NOT_AVAILABLE_DAILY_LIMIT: '/not-available/daily-limit',
    NOT_AVAILABLE_RETAILER_LIMIT: '/not-available/retailer-limit',
    NOT_AVAILABLE_CAMPAIGN_LIMIT: '/not-available/campaign-limit',
    NOT_AVAILABLE_VENUE_OFF: '/not-available/venue-closed',
    NOT_AVAILABLE_RETAILER_OFF: '/not-available/retailer-closed',
    NO_LOCATION: '/no-location',
    ALREADY_SIGNED_UP: '/already-signed-up',

    EXTERNAL_INSTANT_WIN_REDEEM: '/external/instant-win/redeem',
    INSTANT_WIN_CHECK_WINNER: '/instant-win/check/:id',
    INSTANT_WIN_WINNER: '/instant-win/winner/:id',
    INSTANT_WIN_PRIZE_REDEEMED: '/instant-win/prize-redeemed',
    INSTANT_WIN_NO_WIN: '/instant-win/no-win',
    INSTANT_WIN_ALREADY_REDEEMED: '/instant-win/already-redeemed',
    INSTANT_WIN_LINK_EXPIRED: '/instant-win/link-expired',
    INSTANT_WIN_LOCATION_CHECK: '/instant-win/location-check/:unique/:type',
    INSTANT_WIN_LOCATION_ERROR: '/instant-win/location-error/:unique/:type',
    INSTANT_WIN_VOUCHER: '/instant-win/voucher',
    INSTANT_WIN_REDEEM_SUCCESS: '/instant-win/redeem-success',
    INSTANT_WIN_SELECT_DIFFERENT_VENUE: '/instant-win/venues/:unique/:type',
    INSTANT_WIN_REDEEM: '/instant-win/redeem',
    INSTANT_WIN_TOO_EARLY: '/instant-win/too-early',
    INSTANT_WIN_RECEIPT_UPLOAD: '/instant-win/upload',

    PREDICTION_LOCATION_CHECK: '/prediction/location-check/:unique',
    PREDICTION_LOCATION_ERROR: '/prediction/location-error/:unique',
    PREDICTION_SELECT_DIFFERENT_VENUE: '/prediction/venues/:unique',
    PREDICTION_SELECT_GAME: '/prediction/select',
    PREDICTION_SUMMARY: '/prediction/summary',
    PREDICTION_PROGRESS: '/prediction/progress/:id',
    PREDICTION_GAME_IN_PROGRESS: '/prediction/game-in-progress',
    PREDICTION_GAME_NOT_STARTED: '/prediction/game-not-started',
    PREDICTION_WINNER: '/prediction/win',
    PREDICTION_LOST: '/prediction/lost',

    GAME_PLAY: '/game/play',
    GAME_RESULT: '/game/result/:unique',
    GAME_NO_WIN: '/game/no-win',
    GAME_THANKS: '/game/thank-you',
    GAME_SELECT_DIFFERENT_VENUE: '/game/venues/:unique',
    GAME_LOCATION_ERROR: '/game/location-error/:unique',
    GAME_LOCATION_CHECK: '/game/location-check/:unique',

    LOYALTY_LOCATION_CHECK: '/loyalty/location-check/:unique',
    LOYALTY_LOCATION_ERROR: '/loyalty/location-error/:unique',
    LOYALTY_SELECT_DIFFERENT_VENUE: '/loyalty/venues/:unique',
    LOYALTY_CONTINUE: '/loyalty/continue/:unique',
    LOYALTY_SWIPE_STEP: '/loyalty/step',
    LOYALTY_STEP_SWIPED: '/loyalty/step/success',
    LOYALTY_COMPLETED: '/loyalty/completed',
    LOYALTY_COME_BACK_LATER: '/loyalty/come-back-later',

    CLAIM: '/claim/:token',
};

export default routeNames;
